import {App} from '@capacitor/app'
import {Capacitor} from '@capacitor/core'
import {useChatSessionStore} from '@src/stores/chatSession'
import useStore from '@src/stores/store'
import {useInternalChatStore} from '@src/stores/internalChat'
import {db} from '@src/services/db'

export function initBackButton(): void {
    if (!Capacitor.isNativePlatform()) return

    App.addListener('backButton', () => {
        const sessionStore = useChatSessionStore()
        const store = useStore()
        const internalChatStore = useInternalChatStore()

        if (store.activeSidebarComponent === 'internal-chat' && internalChatStore.selectedUserId) {
            internalChatStore.clearSelection()
        } else if (sessionStore.selectedSession) {
            sessionStore.clearSession()
        } else if (store.activeSidebarComponent !== 'active') {
            store.activeSidebarComponent = 'active'
        } else {
            App.exitApp()
        }
    })
}

export async function navigateToSession(sessionId: number): Promise<void> {
    const store = useStore()
    if (store.status !== 'success') return

    const session = await db.sessions.get(sessionId)
    if (!session) return

    const sessionStore = useChatSessionStore()
    store.activeSidebarComponent = 'active'
    await sessionStore.selectSession(session)
}
